// extracted by mini-css-extract-plugin
export var container = "_du-0";